import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';

import ListItems from './ListItems';

const Panels = ({
    disabled,
    fetchPanelBrands,
    fetchPanels,
    initialValues,
    isFetching,
    isFetchingPanelBrands,
    paginationData,
    panelBrands,
    panels,
    setValue,
}) => {
    const [filterData, setFilterData] = useState({
        brandName: '',
        financierProductId: initialValues?.id,
        page: 0,
        pageSize: 25,
        searchText: '',
    });

    useEffect(() => {
        fetchPanelBrands();
        fetchPanels(filterData);
    }, []);

    return (
        <ListItems
            disabled={disabled}
            brands={panelBrands}
            fieldName="panels_list"
            filterData={filterData}
            filterItems={fetchPanels}
            isFetching={isFetching}
            isFetchingBrands={isFetchingPanelBrands}
            items={panels}
            paginationData={paginationData}
            setFilterData={setFilterData}
            setValue={setValue}
            value={initialValues?.panels_list}
        />
    );
};

Panels.propTypes = {
    disabled: PropTypes.bool,
    fetchPanelBrands: PropTypes.func,
    fetchPanels: PropTypes.func,
    initialValues: PropTypes.object,
    isFetching: PropTypes.bool,
    isFetchingPanelBrands: PropTypes.bool,
    paginationData: PropTypes.object,
    panelBrands: PropTypes.array,
    panels: PropTypes.array,
    setValue: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isFetching: selectors.getPanelsIsFetching,
    isFetchingPanelBrands: selectors.getIsFetchingPanelBrands,
    paginationData: selectors.getPanelsPagination,
    panelBrands: selectors.getPanelBrandsData,
    panels: selectors.getPanelsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPanelBrands: () => dispatch(actions.fetchPanelBrands()),
    fetchPanels: (filterData) => dispatch(actions.fetchPanels(filterData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Panels);
